<template>
    <div class="all-height">
        <el-main class="all-height">
            <div class="all-height">
                <div class="operation-bar">
                    <h1>菜单管理</h1>
                    <div class="operation-bar-right">
                        <a href="javascript:void(0)"  @click="addMenuItem">添加</a>
                        <a href="javascript:void(0)" @click="editMenuItem">编辑</a>
                        <a href="javascript:void(0)" @click="moveUp">上移</a>
                        <a href="javascript:void(0)" @click="moveDown">下移</a>
                        <a href="javascript:void(0)" @click="delMenuItem">删除</a>
                    </div>
                </div>
                <div class="table-box">
                    <el-table ref="table" :data="menuInfoData" height="100%" highlight-current-row
                        :header-cell-style="{background:'#4885CA',color: 'white'}"
                        row-key="pkMenuItem"
                        :lazy="true"
                        @selection-change="selsChange"
                        :load="loadDataList"
                        :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
                    >
                        <el-table-column type="selection" header-align="center" align="center">
                        </el-table-column>
                        <el-table-column property="name" label="名称" width="200" header-align="center" align="center">
                        </el-table-column>
                        <el-table-column property="code" label="编码" width="100" header-align="center" align="center">
                        </el-table-column>
                        <el-table-column property="status" label="状态" width="80" header-align="center" align="center">
                            <template slot-scope="scope">
                                {{scope.row.state === 1?'未启用':(scope.row.state === 2?'已启用':'已禁用')}}
                            </template>
                        </el-table-column>
                        <el-table-column property="menuIcon" label="图标" width="200" header-align="center" align="center">
                            <template slot-scope="scope">
                                <i class="iconfont" :class="scope.row.menuIcon"></i>
                            </template>
                        </el-table-column>
                        <el-table-column property="path" label="路径" align="left" header-align="center">
                        </el-table-column>
                        <el-table-column property="createUser" label="创建人" width="100" header-align="center" align="center">
                        </el-table-column>
                        <el-table-column property="createTime" label="创建时间" width="200" header-align="center" align="center">
                            <template slot-scope="scope">
                                {{dateFormat(scope.row.createTime)}}
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </el-main>
        <menu-dialog ref="menuDialog" :title="menuDialogTitle" @closeHandler="refreshTable"></menu-dialog>
    </div>
</template>

<script>
    import MenuDialog from './menu-dialog'
    import dayjs from 'dayjs';
    export default {
        name: 'menuOperation',
        components: {MenuDialog},
        data() {
            return {
                btnDisable: true,
                addBtnDisable: false,
                menuInfoData: [],
                name:'',
                menuDialogTitle: '',
                maps: new Map()
            }
        },
        methods: {
            moveUp() {
                //上移
                if(this.$refs.table.selection.length === 1) {
                    var item = this.$refs.table.selection[0];
                    this.$store.dispatch("system/menuItem/moveUp", {pkMenuItem: item.pkMenuItem,faMenuItem: item.faMenuItem,sort: item.sort}).then((res) => {
                        if(res.code === '200') {
                            this.$message({
                                message: '操作成功！',
                                type: 'success'
                            });
                            this.refreshTable(item);
                        } else{
                            this.$message.error(res.data?res.data : res.message);
                        }
                    });
                }
            },
            moveDown() {
                //下移
                if(this.$refs.table.selection.length === 1) {
                    var item = this.$refs.table.selection[0];
                    this.$store.dispatch("system/menuItem/moveDown", {pkMenuItem: item.pkMenuItem,faMenuItem: item.faMenuItem,sort: item.sort}).then((res) => {
                        if(res.code === '200') {
                            this.$message({
                                message: '操作成功！',
                                type: 'success'
                            });
                            this.refreshTable(item);
                        } else{
                            this.$message.error(res.data?res.data : res.message);
                        }
                    });
                }
            },
            addMenuItem() {
                //进行添加操作
                var sels = this.$refs.table.selection;
                if(sels.length === 0 || sels.length === 1) {
                    this.$refs.menuDialog.show(sels[0],'add');
                    this.menuDialogTitle = '添加菜单';
                } else {
                    this.$message.error('请选择一项作为父节点');
                }
            },
            editMenuItem(row, column, event) {
                if(this.$refs.table.selection.length === 1) {
                    var item = JSON.parse(JSON.stringify(this.$refs.table.selection[0]));
                    //进行修改操作
                    this.$refs.menuDialog.show(item,'edit');
                    this.menuDialogTitle = '修改菜单';
                } else {
                    this.$message.error('请选择一项进行编辑');
                }
            },
            delMenuItem() {
                if(this.$refs.table.selection.length === 1) {
                    this.$confirm('删除已选菜单, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'info'
                    }).then(() => {
                        //进行删除操作
                        var item = this.$refs.table.selection[0];
                        this.$store.dispatch("system/menuItem/delete", {pkMenuItem: item.pkMenuItem}).then((res) => {
                            if(res.code === '200') {
                                this.$message({
                                    message: '操作成功！',
                                    type: 'success'
                                });
                                this.refreshTable(item);
                            } else {
                                this.$message.error('存在子项，删除失败！');
                            }
                        });
                    });
                }
            },
            loadDataList(tree, treeNode, resolve) {
                var param = {
                    isShowAll: 1
                };
                if(!tree) {
                    param.faMenuItem = "~";
                } else {
                    param.faMenuItem = tree.pkMenuItem;
                    const pid = tree.pkMenuItem;
                    this.maps.set(pid,{ tree, treeNode, resolve });
                }
                param.name = this.name;
                this.$store.dispatch("system/menuItem/list", param).then((res) => {
                    res.forEach((item) => {
                        if (item.leafNode === 0) {
                            item.hasChildren = true;
                        }
                    });
                    if(!tree) {
                        this.menuInfoData = res;
                    } else {
                        tree.childen = res;
                    }
                    if(resolve) {
                        resolve(res);
                    }
                });
            },
            dateFormat(val) {
                if (val) {
                    return dayjs(val).format('YYYY-MM-DD hh:mm:ss');
                } else {
                    return '';
                }
            },
            refreshTable(item, type) {
                this.$refs.table.clearSelection();
                if(item.faMenuItem !== '~') {
                    if(this.maps.get(item.faMenuItem)) {
                        const { tree, treeNode, resolve } = this.maps.get(item.faMenuItem);
                        this.$set(this.$refs.table.store.states.lazyTreeNodeMap, item.faMenuItem, []);
                        this.loadDataList(tree, treeNode, resolve);
                        return;
                    }
                }
                this.loadDataList();
            },
            selsChange(sels) {
                if(sels.length === 1) {
                    this.btnDisable = false;
                    if(sels[0].faMenuItem !== '~' && this.maps.get(sels[0].faMenuItem)) {
                        this.addBtnDisable = true;
                    } else {
                        this.addBtnDisable = false;
                    }
                } else {
                    this.btnDisable = true;
                    if (sels.length === 0) {
                        this.addBtnDisable = false;
                    } else {
                        this.addBtnDisable = true;
                    }
                }
            }
        },
        created() {
            this.loadDataList();
        }
    };
</script>

<style scoped>
    .table-box {
        margin-top: 5px;
        height: calc(100% - 35px);
    }
</style>
